// Pure helper for ordering TOTP authenticators in the Settings management panel.
// Kept in its own module (no DOM/config imports) so it is unit-testable in node.
import type { AuthMethod } from '../api/types.js';

// Sort authenticators newest-first by created_at (missing dates sort last).
export function sortAuthenticators(auths: AuthMethod[]): AuthMethod[] {
  return [...auths].sort((a, b) => {
    const ta = a.created_at ? Date.parse(a.created_at) : 0;
    const tb = b.created_at ? Date.parse(b.created_at) : 0;
    return tb - ta;
  });
}
